import { render, staticRenderFns } from "./Remitentes.vue?vue&type=template&id=34a1523a&"
import script from "./Remitentes.vue?vue&type=script&lang=js&"
export * from "./Remitentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports